module.exports = __webpack_public_path__ + "static/media/shoppingcart.0ac1d2bf.png";